module.exports = __webpack_public_path__ + "static/media/allianz-parque2.877d28ae.jpeg";